<template>
  <div
    :class="[
      'component-form-wizard-header-bar',
      {
        'component-form-wizard-header-bar--is-requesting': isRequesting
      }
    ]"
  >
    <div class="component-form-wizard-header-bar__logo">
      <router-link :to="logoLink">
        <img
          src="@/assets/img/hub-2023.png"
          width="66"
          height="30"
          alt="The Hub logo"
        />
      </router-link>
      <h2
        v-if="title"
        class="component-form-wizard-header-bar__logo__title ml-40 pt-4 hidden-sm"
      >
        {{ title }}
      </h2>
    </div>
    <nav v-if="!hideActions" class="component-form-wizard-header-bar__actions">
      <div
        class="component-form-wizard-header-bar__actions__item component-form-wizard-header-bar__actions__item--time-ago"
      >
        <TimeAgo
          v-if="lastUpdatedAt"
          :date="lastUpdatedAt"
          just-now-text="Saved a few seconds ago"
          prefix-text="Last saved "
          class="fs15 text-gray-600"
        />
      </div>

      <div
        class="component-form-wizard-header-bar__actions__item component-form-wizard-header-bar__actions__item--menu"
      >
        <button class="btn btn-link fs15" @click="onToggleMobileMenu">
          Menu
        </button>
      </div>

      <div
        class="component-form-wizard-header-bar__actions__item component-form-wizard-header-bar__actions__item--save"
      >
        <button class="btn btn-link fs15" @click="onSaveAndExit">
          <span
            class="component-form-wizard-header-bar__actions__item__btn-text component-form-wizard-header-bar__actions__item__btn-text--long"
            >Save and exit</span
          >
          <span
            class="component-form-wizard-header-bar__actions__item__btn-text component-form-wizard-header-bar__actions__item__btn-text--short"
            >Save</span
          >

          <div
            v-if="isRequesting"
            class="component-form-wizard-header-bar__actions__item__spinner"
          >
            <b-spinner small />
          </div>
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import TimeAgo from '@/components/TimeAgo'

export default {
  name: 'CreateHeader',
  components: {
    TimeAgo
  },
  props: {
    title: {
      type: String
    },
    lastUpdatedAt: String,
    logoLink: {
      type: String,
      default: '/'
    },
    onToggleMobileMenu: {
      type: Function,
      required: true
    },
    onSaveAndExit: {
      type: Function,
      required: true
    },
    hideActions: Boolean,
    isRequesting: Boolean
  },
  data() {
    return {
      data: this.$parent.data
    }
  }
}
</script>

<style lang="scss">
.component-form-wizard-header-bar {
  height: $header-height;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  border-bottom: 1px solid $border-color;

  &__logo {
    display: flex;
    align-items: center;

    &__image {
      margin-top: -4px;
      height: rem(30px);
      width: rem(139px);
    }

    &__title {
      font-size: 1rem;
      font-weight: 400;
      letter-spacing: -0.5px;
    }
  }

  &__actions {
    display: flex;
    align-items: center;

    &__item {
      border-right: 1px solid $border-color;
      padding: 0.05rem 1rem;

      &:last-child {
        border-right: 0;
        padding-right: 0;
      }

      &--menu {
        display: none;
      }

      &--save & {
        &__btn-text--long {
          display: block;
        }

        &__btn-text--short {
          display: none;
        }
      }

      &__spinner {
        position: absolute;
        top: 0;
        right: 50%;
        bottom: 0;
        transform: translate(50%, 0);
      }
    }
  }

  @include media-breakpoint-down(sm) {
    &__logo {
      &__title {
        display: none;
      }
    }

    &__actions {
      &__item {
        position: relative;

        &--time-ago {
          display: none;
        }

        &--menu {
          display: block;
        }

        &--save & {
          &__btn-text--long {
            display: none;
          }

          &__btn-text--short {
            display: block;
          }
        }
      }
    }
  }

  &--is-requesting {
    .component-form-wizard-header-bar__actions__item__btn-text {
      opacity: 0;
    }
  }

  @include media-breakpoint-down(xs) {
    padding: 0 1rem;
  }
}
</style>
